import { useFormContext } from "react-hook-form";
import { Textarea } from "../ui/textarea";
import { cn } from "@/lib/utils";

interface CustomFieldSectionProps {
    fieldKey: "custom_1" | "custom_2" | "custom_3";
}

export default function CustomFieldSection({ fieldKey }: CustomFieldSectionProps) {
    const { register } = useFormContext();

    return (
        <div className="space-y-2">
            <Textarea
                {...register(`custom_fields.${fieldKey}`)}
                placeholder="Add details..."
                rows={1}
                className={cn(
                    // Same box as the Tests / Diagnosis fields
                    "text-sm bg-card shadow-none min-h-9 touch:min-h-10 py-[7px] px-2.5 resize-none",
                    "hover:border-ring/60 focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary",
                    "placeholder:text-muted-foreground/60 placeholder:font-normal",
                )}
                maxLength={1000}
            />
        </div>
    );
}
